import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EyeOffGlyph = /*#__PURE__*/createElement("g", {
  id: "eye_off"
}, /*#__PURE__*/createElement("path", {
  d: "M69.05 41.01c-.3-.34-4.72-5.34-11.46-9.23l-2.24 2.24c5.01 2.76 8.83 6.29 10.5 7.98C62.89 45 53.23 53.81 42 53.81c-1.95 0-3.86-.28-5.69-.74l-2.45 2.45c2.56.8 5.29 1.29 8.14 1.29 14.81 0 26.56-13.26 27.05-13.82.49-.57.49-1.41 0-1.98z"
}), /*#__PURE__*/createElement("path", {
  d: "M41.88 51.98c6.43 0 11.63-5.22 11.64-11.64 0-1.34-.23-2.63-.65-3.83L38.05 51.32c1.2.42 2.49.66 3.83.66zM54.82 30.32c-3.8-1.81-8.15-3.13-12.82-3.13-14.83 0-26.56 13.26-27.05 13.82-.49.57-.49 1.41 0 1.97.36.41 6.68 7.54 15.8 11.39l2.33-2.33c-7.17-2.72-12.8-7.89-14.94-10.05 2.26-2.28 8.41-7.92 16.16-10.49-2.49 2.14-4.07 5.3-4.07 8.83 0 3.96 1.98 7.45 5.01 9.56L51.43 33.7c-.6-.86-1.29-1.64-2.09-2.31 1.1.35 2.16.76 3.19 1.22l2.29-2.29zm-17.3 10.14a3.82 3.82 0 110-7.64 3.82 3.82 0 010 7.64z"
}), /*#__PURE__*/createElement("path", {
  d: "M18.86 65.64c-.38 0-.77-.15-1.06-.44a1.49 1.49 0 010-2.12l44.29-44.29a1.49 1.49 0 012.12 0c.59.59.59 1.54 0 2.12l-44.29 44.3c-.3.29-.68.43-1.06.43z"
}));
const EyeOf = createSvg({
  name: 'eye_off',
  path: EyeOffGlyph
});

export default EyeOf;
export { EyeOffGlyph };
